"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicCampaignBanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const hooks_1 = require("../../../hooks");
const url_join_1 = __importDefault(require("url-join"));
function DynamicCampaignBanner({ show = false, css, floraSection, name, catalogSlug, }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const isMobile = (0, flora_react_1.useIsMobile)();
    const { data: bannerContent, isLoading: isLoadingBannerInfo } = (0, hooks_1.useDynamicBanner)({
        componentName: name,
        resellerSlug: catalogSlug,
    });
    const destinationUrl = (_b = (_a = bannerContent === null || bannerContent === void 0 ? void 0 : bannerContent.options) === null || _a === void 0 ? void 0 : _a.urlDestinoMld) === null || _b === void 0 ? void 0 : _b.url;
    const destinationHref = (0, url_join_1.default)(window.location.origin, catalogSlug, destinationUrl !== null && destinationUrl !== void 0 ? destinationUrl : '');
    const isVisible = show && !isLoadingBannerInfo;
    const showDesktopContent = !isMobile && bannerContent && ((_d = (_c = bannerContent === null || bannerContent === void 0 ? void 0 : bannerContent.options) === null || _c === void 0 ? void 0 : _c.desktop) === null || _d === void 0 ? void 0 : _d.url);
    const showMobileContent = isMobile && bannerContent && ((_f = (_e = bannerContent === null || bannerContent === void 0 ? void 0 : bannerContent.options) === null || _e === void 0 ? void 0 : _e.mobile) === null || _f === void 0 ? void 0 : _f.url);
    const shouldShow = isVisible && (showMobileContent || showDesktopContent);
    const bannerImageProps = showDesktopContent
        ? (_g = bannerContent === null || bannerContent === void 0 ? void 0 : bannerContent.options) === null || _g === void 0 ? void 0 : _g.desktop
        : (_h = bannerContent === null || bannerContent === void 0 ? void 0 : bannerContent.options) === null || _h === void 0 ? void 0 : _h.mobile;
    const imageSrc = bannerImageProps === null || bannerImageProps === void 0 ? void 0 : bannerImageProps.url;
    const imageCommonProps = {
        fit: 'contain',
        src: imageSrc,
        alt: (bannerImageProps === null || bannerImageProps === void 0 ? void 0 : bannerImageProps.alt) || '',
        css: {
            width: '100%',
            height: '100%',
            maxWidth: '100vw',
            pointerEvents: 'none',
        },
    };
    const commonProps = {
        'autotagging-flora': 'on',
        'data-flora-text': (_j = bannerImageProps === null || bannerImageProps === void 0 ? void 0 : bannerImageProps.alt) !== null && _j !== void 0 ? _j : '',
        'data-flora': 'button',
        'data-autotagging-flora-section': floraSection,
        justify: 'center',
        css,
    };
    if (!shouldShow)
        return null;
    if (destinationUrl) {
        return ((0, jsx_runtime_1.jsx)(flora_react_1.Flex, Object.assign({ as: "a", href: destinationHref, "aria-label": bannerImageProps === null || bannerImageProps === void 0 ? void 0 : bannerImageProps.alt }, commonProps, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Image, Object.assign({}, imageCommonProps, { "aria-hidden": true })) })));
    }
    return ((0, jsx_runtime_1.jsx)(flora_react_1.Flex, Object.assign({}, commonProps, { as: "div" }, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Image, Object.assign({}, imageCommonProps)) })));
}
exports.DynamicCampaignBanner = DynamicCampaignBanner;
